import React from 'react'
import CommentDialog from '../../../../components/CommentsPopUp'
import PreFormComments from "./index";

const PreCommentsDialog = ({onClose, onPost,projectId,project,formId, ...props}) =>
    <CommentDialog
        {...props} onClose={onClose}

        body={<PreFormComments {...props} onClose={onClose} projectId={projectId} project={project} formId={formId} />}

    />

export default PreCommentsDialog;